const patientData = (state = [], action) => {
    switch(action.type){
        case 'PATIENT_LIST_RECEIVE_DATA_API':
            state = action.payload;   
            localStorage.setItem('patient_data',JSON.stringify(state))
            return state;  
        case 'PATIENT_TOGGLE':
                let indexValue = action.payload;
                const updateArray = [...state]; 
                let areWeOpen;
                //check if already open we need to close the toggle
                if(updateArray[indexValue].is_open === true){
                    areWeOpen = false; 
                }else{
                    areWeOpen = true;  
                } 
                state.map((item) =>  item.is_open = false)
                state[indexValue].is_open = areWeOpen; 
          return [...state]; 

        case 'PATIENT_SEARCH':
            const text = action.payload;
            const allData = JSON.parse(localStorage.getItem('patient_data')); 
            const filterData = allData.filter(item => {   
                let itemData = `${item.first_name.toUpperCase()+item.mobile_number}`; 
                if(item.last_name != undefined){
                    itemData += item.last_name.toUpperCase();
                }
                let textData = text.toUpperCase(); 
                return itemData.indexOf(textData) > -1;    
            });  
            state = filterData;  
            return state;  
            
        case 'ASSINGMENT_INSERT_NOTES':
            let AssingmentIndexValue = action.payload.indexValue; 
            let notes = action.payload.notes; 
            let notesList = state[AssingmentIndexValue].notes_lists; 
            state[AssingmentIndexValue].notes_lists = [...notesList, ...[notes]] 
            return [...state];

        default:
              return state;

    }
};

export default patientData;